// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AttributeLookupModel from '../../model/attribute-lookup-model';
import AttributeLookupDTO from '../dto/attribute-lookup-dto';
import dtoSchema from '../schemas/attribute-lookup-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class AttributeLookupModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AttributeLookupDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.caption = data.caption ?? undefined;
      this.details = data.details ?? undefined;
      this.sort = data.sort;
      this.childKey = data.childKey ?? undefined;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  caption?: string;
  /**
  */
  details?: string;
  /**
  * @type {int32}
  */
  sort?: number;
  /**
  */
  childKey?: string;

  static toModel(dto: DeepPartial<AttributeLookupDTO>): AttributeLookupModel;
  static toModel(dto: DeepPartial<AttributeLookupDTO> | undefined | null): AttributeLookupModel | undefined;
  static toModel(dto: DeepPartial<AttributeLookupDTO> | undefined | null): AttributeLookupModel | undefined {
    return dto ? new AttributeLookupModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AttributeLookupModel> | AttributeLookupModel): AttributeLookupDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      caption: unwrapped.caption,
      details: unwrapped.details,
      sort: unwrapped.sort,
      childKey: unwrapped.childKey,
    } as AttributeLookupDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AttributeLookupModel, can not map to AttributeLookupDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
